import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import styles from './common.module.scss';

import { FieldNumber, FieldText } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  const direction = useMemo(() => {
    switch (command.data.direction) {
      case -1:
        return 'Counter-Clockwise';
      case 0:
        return 'Shortest';
      case 1:
        return 'Clockwise';
      default:
        break;
    }
  }, [command.data.direction]);

  const offset = useMemo(() => {
    switch (command.data.offset) {
      case 0:
        return 'Absolute';
      case 1:
        return 'Relative';
      default:
        break;
    }
  }, [command.data.offset]);

  return (
    <div className={cx('container')}>
      <label>
        Direction
        <div className={cx('fieldWrapper')}>
          <FieldText value={direction} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
      <label>
        Offset
        <div className={cx('fieldWrapper')}>
          <FieldText value={offset} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
      <label>
        Heading
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.heading.toFixed(1)} readOnly />
          <span className={cx('unit')}>deg</span>
        </div>
      </label>
      <label>
        Rate
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.rate.toFixed(1)} readOnly />
          <span className={cx('unit')}>deg/s</span>
        </div>
      </label>
    </div>
  );
};

export default Item;
